import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/llm-configuration/generative-ai-models')
export class LLMProviderModelListDto extends DtoHasApi {
  models: string[];
  success: boolean;
}
